import { useEffect, useState } from "react";

const useIsMobile = (maxWidth = 768) => {
    const [isMobile, setIsMobile] = useState(false);
  
    useEffect(() => {
      const checkIsMobile = () => {
        setIsMobile(window.innerWidth <= maxWidth);
      };
  
      checkIsMobile();
      window.addEventListener("resize", checkIsMobile);
  
      return () => {
        window.removeEventListener("resize", checkIsMobile);
      };
    }, [maxWidth]);
  
    return isMobile;
};
  
export default useIsMobile;